module.exports = __webpack_public_path__ + "img/habanero.6fc78372.png";